// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f3e1c681","890":"6a6fa975"}[chunkId] + ".chunk.js";
};